import apiURL from "../store/actions/apiURL";
import {
	getAccessToken,
	setAccessToken,
	getRefreshToken,
	setRefreshToken,
	clearAllTokens,
} from "./authToken";

let refreshPromise = null;

const shouldSkipRefresh = (url) => url?.includes("/authentication/refresh");

const refreshAccessToken = async () => {
	const refreshToken = getRefreshToken();
	if (!refreshToken) {
		throw new Error("No refresh token available");
	}

	const currentAccessToken = getAccessToken();
	const headers = {
		"Accept": "application/json",
		"Content-Type": "application/json",
	};

	if (currentAccessToken) {
		headers.Authorization = `Bearer ${currentAccessToken}`;
	}

	const response = await fetch(`${apiURL}/authentication/refresh`, {
		method: "POST",
		body: JSON.stringify({ refreshToken }),
		credentials: "include",
		headers,
	});

	if (!response.ok) {
		throw new Error("Unable to refresh access token");
	}

	const data = await response.json();
	const newAccessToken = data.accessToken || data.token;
	if (newAccessToken) {
		setAccessToken(newAccessToken);
	}

	if (data.refreshToken) {
		setRefreshToken(data.refreshToken);
	}

	return newAccessToken;
};

export const authFetch = async (url, options = {}, config = {}) => {
	const { skipAuth = false, skipRefresh = false } = config;
	const headers = {
		...(options.headers ?? {}),
	};

	const accessToken = getAccessToken();
	if (!skipAuth && accessToken && !headers.Authorization && !headers.authorization) {
		headers.Authorization = `Bearer ${accessToken}`;
	}

	const response = await fetch(url, {
		credentials: "include",
		...options,
		headers,
	});

	if (response.status !== 401 || skipRefresh || shouldSkipRefresh(url)) {
		return response;
	}

	const refreshToken = getRefreshToken();
	if (!refreshToken) {
		return response;
	}

	try {
		if (!refreshPromise) {
			refreshPromise = refreshAccessToken().finally(() => {
				refreshPromise = null;
			});
		}

		const newAccessToken = await refreshPromise;
		if (!newAccessToken) {
			return response;
		}

		const retryHeaders = {
			...(options.headers ?? {}),
			Authorization: `Bearer ${newAccessToken}`,
		};

		return fetch(url, {
			credentials: "include",
			...options,
			headers: retryHeaders,
		});
	} catch (error) {
		clearAllTokens();
		return response;
	}
};
